// extracted by mini-css-extract-plugin
export default {"stuffBetaGamaMint":"StuffBetaGamaMint_stuffBetaGamaMint__XZLuL","scratcherStack":"StuffBetaGamaMint_scratcherStack__zafCV"};